import React from 'react';
import { PreviewMode } from '../../preview-elements/preview-context';
import EmailSmall from 'wix-ui-icons-common/EmailSmall';
import AdminAccessSmall from 'wix-ui-icons-common/AdminAccessSmall';
import PublicSmall from 'wix-ui-icons-common/PublicSmall';
import s from './solution-overview.scss';
import { composer } from '../../../../component-decorators/composer';
import { IconPreviewWrapper } from '../../preview-elements/icon-wrapper';
import { SupportLinkPreviewWrapper, PrivacyLinkPreviewWrapper, DevSiteLinkWrapper, } from '../../preview-elements/developer-card-wrappers/';
import { DevelopedByWrapper } from '../../preview-elements';
import { biLogger } from '../../../../bi';
import { Text, Box, Avatar, Card, TextButton } from 'wix-style-react';
import { getClientImageURL } from '../../../../common/getClientImageURL';
import { ModalNames } from '../../../modals/modals';
import { useConfigContext } from '../../../../config-context';
import { isWixApp, wixChatBotLink } from '../../../../common/utils';
export var dtoToDevCardProps = function (solutionDto) {
    var baseInfo = solutionDto.baseInfo;
    var assetsMap = solutionDto.assetsMap;
    var company = solutionDto.company;
    var webSolutionData = solutionDto.webSolutionData;
    var supportEmail = solutionDto.supportEmails && solutionDto.supportEmails.join(';');
    var website = solutionDto.company ? solutionDto.company.website : undefined;
    var name = solutionDto.company
        ? solutionDto.company.companyBase.name
        : 'Dev Name'; //TODO FIX
    var icon = solutionDto.company &&
        solutionDto.company.assetsMap &&
        solutionDto.company.assetsMap.companyIcon &&
        solutionDto.company.assetsMap.companyIcon.assets &&
        solutionDto.company.assetsMap.companyIcon.assets[0].url;
    var id = solutionDto.baseInfo.id;
    var privacyPolicyUrl = solutionDto.company.privacyPolicyUrl;
    return {
        website: website,
        name: name,
        icon: icon,
        supportEmail: supportEmail,
        privacyPolicyUrl: privacyPolicyUrl,
        id: id,
        baseInfo: baseInfo,
        assetsMap: assetsMap,
        company: company,
        webSolutionData: webSolutionData,
    };
};
export var DeveloperCard = composer()
    .withTranslation()
    .withMarketplaceStore()
    .withExperiments()
    .compose(function (props) {
    var _a;
    var appFromInstalled = props.marketplaceStore.installedApps && ((_a = props.marketplaceStore.installedApps) === null || _a === void 0 ? void 0 : _a.find(function (installedApp) { return installedApp.webSolutionBase.id === props.baseInfo.id; }));
    var madeByWix = props.company &&
        props.company.companyBase &&
        isWixApp(props.company.companyBase.id);
    // tslint:disable-next-line: react-hooks-nesting
    var shouldUseSupportModal = useConfigContext().shouldUseSupportModal;
    return (React.createElement(PreviewMode.Consumer, null, function (value) {
        return value.isPreview || haveSomeLink(props) ? (React.createElement(Card, { className: s.sideCardContainer },
            React.createElement("div", { "data-testid": "developer-card" }),
            React.createElement(DevelopedBy, { icon: props.icon, name: props.name }),
            React.createElement(Card.Divider, null),
            React.createElement(Box, { paddingTop: '18px', paddingBottom: '18px', paddingRight: '24px', paddingLeft: '24px', direction: "vertical" },
                React.createElement(DeveloperSiteLink, { href: props.website, onClick: function () {
                        return sendDeveloperContactBoxActionClickBi('visit_website', props.id, props.marketplaceStore.metaSiteId);
                    } }),
                madeByWix ? (React.createElement(WixChatBotLink, { href: wixChatBotLink, onClick: function () {
                        return sendDeveloperContactBoxActionClickBi('contact_support', props.id, props.marketplaceStore.metaSiteId);
                    } })) : (props.experiments.enabled('specs.marketplace.manage-apps.support-modal') ||
                    props.experiments.enabled("specs.marketplace.support-modal-for-" + props.id)) &&
                    shouldUseSupportModal &&
                    appFromInstalled ? (React.createElement(DeveloperEmailLinkWithSupportModal, { href: props.supportEmail, onClick: function () {
                        sendDeveloperContactBoxActionClickBi('contact_support', props.id, props.marketplaceStore.metaSiteId);
                        props.marketplaceStore.openModal(ModalNames.SUPPORT_MODAL, {
                            // @ts-ignore
                            app: appFromInstalled
                                ? appFromInstalled
                                : props,
                            closeModal: function () {
                                return props.marketplaceStore.closeAllModals();
                            },
                            clickSource: 'developerEmailLink',
                            pageName: 'app_page',
                        });
                    } })) : (React.createElement(DeveloperEmailLink, { href: props.supportEmail, onClick: function () {
                        return sendDeveloperContactBoxActionClickBi('contact_support', props.id, props.marketplaceStore.metaSiteId);
                    } })),
                React.createElement(DeveloperPrivacyPolicyPage, { href: props.privacyPolicyUrl, onClick: function () {
                        return sendDeveloperContactBoxActionClickBi('privacy', props.id, props.marketplaceStore.metaSiteId);
                    } })))) : (React.createElement("div", null));
    }));
});
var haveSomeLink = function (props) {
    if (props) {
        var website = props.website, supportEmail = props.supportEmail, privacyPolicyUrl = props.privacyPolicyUrl;
        return website || supportEmail || privacyPolicyUrl;
    }
    return false;
};
var sendDeveloperContactBoxActionClickBi = function (actionName, appId, msid) {
    biLogger.appMarketDeveloperContactBoxActionClick({
        actionName: actionName,
        app_id: appId,
        msid: msid,
        tag_name: appId,
        tag_type: 'solution_page',
    });
};
var DevelopedBy = composer()
    .withTranslation()
    .compose(function (props) {
    return (React.createElement(Box, { verticalAlign: "middle", className: s.devCardBy },
        React.createElement(IconPreviewWrapper, { size: "62px", src: props.icon }, props.icon ? (React.createElement(Avatar, { size: "size36", imgProps: {
                src: getClientImageURL(props.icon, {
                    toHeight: 36,
                    toWidth: 36,
                }),
                alt: "developed by " + props.name,
            } })) : (React.createElement(Avatar, { size: "size48", name: 'Cohav Nofar', color: 'A1' }))),
        React.createElement(Box, { marginLeft: '12px', direction: "vertical" },
            React.createElement(Text, { size: 'small', weight: 'thin', secondary: true }, props.t('solution.page.devCardBy')),
            React.createElement(DevelopedByWrapper, { name: props.name },
                React.createElement(Text, { size: 'medium', weight: "bold", dataHook: "dev-card-name" }, props.name)))));
});
var DeveloperSiteLink = composer()
    .withTranslation()
    .compose(function (props) {
    return (React.createElement(DevSiteLinkWrapper, { href: props.href }, props.href ? (React.createElement(Box, { verticalAlign: "middle", paddingBottom: 1, className: s.devCardLinkContainer },
        React.createElement(TextButton, { size: "small", dataHook: "developer-website-link", prefixIcon: React.createElement(PublicSmall, null), as: "a", href: props.href, target: "_blank", onClick: function () { return props.onClick(); } }, props.t('solution.page.devCardVisitLink')))) : (React.createElement("div", null))));
});
var DeveloperEmailLink = composer()
    .withTranslation()
    .compose(function (props) {
    return (React.createElement(SupportLinkPreviewWrapper, { href: props.href }, props.href ? (React.createElement(Box, { verticalAlign: "middle", paddingTop: 1, paddingBottom: 1, className: s.devCardLinkContainer },
        React.createElement(TextButton, { size: "small", dataHook: "developer-email-link", prefixIcon: React.createElement(EmailSmall, null), as: "a", href: "mailto:" + props.href, onClick: function () { return props.onClick(); } }, props.t('solution.page.devCardContactUs')))) : (React.createElement("div", null))));
});
var WixChatBotLink = composer()
    .withTranslation()
    .compose(function (props) {
    return (React.createElement(SupportLinkPreviewWrapper, { href: props.href },
        React.createElement(Box, { verticalAlign: "middle", paddingTop: 1, paddingBottom: 1, className: s.devCardLinkContainer },
            React.createElement(TextButton, { size: "small", dataHook: "developer-email-link", prefixIcon: React.createElement(EmailSmall, null), as: "a", href: props.href, onClick: function () { return props.onClick(); }, target: "_blank" }, props.t('solution.page.devCardContactUs')))));
});
var DeveloperEmailLinkWithSupportModal = composer()
    .withTranslation()
    .compose(function (props) {
    return (React.createElement(SupportLinkPreviewWrapper, { href: props.href },
        React.createElement(Box, { verticalAlign: "middle", paddingTop: 1, paddingBottom: 1, className: s.devCardLinkContainer },
            React.createElement(TextButton, { size: "small", dataHook: "developer-email-link", prefixIcon: React.createElement(EmailSmall, null), as: "a", onClick: function () { return props.onClick(); } }, props.t('solution.page.devCardContactUs')))));
});
var DeveloperPrivacyPolicyPage = composer()
    .withTranslation()
    .compose(function (props) {
    return (React.createElement(PrivacyLinkPreviewWrapper, { href: props.href }, props.href ? (React.createElement(Box, { verticalAlign: "middle", paddingTop: 1, className: s.devCardLinkContainer },
        React.createElement(TextButton, { size: "small", dataHook: "developer-privacy-link", prefixIcon: React.createElement(AdminAccessSmall, null), as: "a", href: props.href, target: "_blank", onClick: function () { return props.onClick(); } }, props.t('solution.page.devCardPrivacyLink')))) : (React.createElement("div", null))));
});
//# sourceMappingURL=solution-developer-card.js.map